import type { BaseOptionType } from 'antd/es/select'

export const relationshipValues = [
  { Code: 'ADOPTF', Display: 'Adoptive father' },
  { Code: 'ADOPTM', Display: 'Adoptive mother' },
  { Code: 'ADOPTP', Display: 'Adoptive parent' },
  { Code: 'Agent', Display: 'Agent of patient' },
  { Code: 'AUNT', Display: 'Aunt' },
  { Code: 'BP', Display: 'Billing contact person' },
  { Code: 'BRO', Display: 'Brother' },
  { Code: 'BROINLAW', Display: 'Brother-in-law' },
  { Code: 'C', Display: 'Emergency Contact' },
  { Code: 'CARER', Display: 'Carer of patient' },
  { Code: 'CHILD', Display: 'Child' },
  { Code: 'CHLDADOPT', Display: 'Adopted child' },
  { Code: 'CHLDFOST', Display: 'Foster child' },
  { Code: 'CHLDINLAW', Display: 'Child-in-law' },
  { Code: 'COUSN', Display: 'Cousin' },
  { Code: 'CP', Display: 'Contact person' },
  { Code: 'DAU', Display: 'Natural daughter' },
  { Code: 'DAUADOPT', Display: 'Adopted daughter' },
  { Code: 'DAUC', Display: 'Daughter' },
  { Code: 'DAUFOST', Display: 'Foster daughter' },
  { Code: 'DAUINLAW', Display: 'Daughter in-law' },
  { Code: 'Dependant', Display: 'Dependant of patient' },
  { Code: 'DOMPART', Display: 'Domestic partner' },
  { Code: 'E', Display: 'Employer' },
  { Code: 'EP', Display: 'Emergency contact person' },
  { Code: 'EXT', Display: 'Extended family member' },
  { Code: 'F', Display: 'Federal Agency' },
  { Code: 'FAMMEMB', Display: 'Family member' },
  { Code: 'FMRSPS', Display: 'Former spouse' },
  { Code: 'FRND', Display: 'Unrelated friend' },
  { Code: 'FTH', Display: 'Father' },
  { Code: 'FTHFOST', Display: 'Foster father' },
  { Code: 'FTHINLAW', Display: 'Father-in-law' },
  { Code: 'FTWIN', Display: 'Fraternal twin' },
  { Code: 'FTWINBRO', Display: 'Fraternal twin brother' },
  { Code: 'FTWINSIS', Display: 'Fraternal twin sister' },
  { Code: 'GESTM', Display: 'Gestational mother' },
  { Code: 'GGRFTH', Display: 'Great grandfather' },
  { Code: 'GGRMTH', Display: 'Great grandmother' },
  { Code: 'GGRPRN', Display: 'Great grandparent' },
  { Code: 'GRFTH', Display: 'Grandfather' },
  { Code: 'GRMTH', Display: 'Grandmother' },
  { Code: 'GRNDCHILD', Display: 'Grandchild' },
  { Code: 'GRNDDAU', Display: 'Granddaughter' },
  { Code: 'GRNDSON', Display: 'Grandson' },
  { Code: 'GRPRN', Display: 'Grandparent' },
  { Code: 'Guardian', Display: 'Guardian of patient' },
  { Code: 'HBRO', Display: 'Half-brother' },
  { Code: 'HSIB', Display: 'Half-sibling' },
  { Code: 'HSIS', Display: 'Half-sister' },
  { Code: 'HUSB', Display: 'Husband' },
  { Code: 'I', Display: 'Insurance Company' },
  { Code: 'INLAW', Display: 'Inlaw' },
  { Code: 'ITWIN', Display: 'Identical twin' },
  { Code: 'ITWINBRO', Display: 'Identical twin brother' },
  { Code: 'ITWINSIS', Display: 'Identical twin sister' },
  { Code: 'MAUNT', Display: 'Maternal aunt' },
  { Code: 'MCOUSN', Display: 'Maternal cousin' },
  { Code: 'MGGRFTH', Display: 'Maternal great-grandfather' },
  { Code: 'MGGRMTH', Display: 'Maternal great-grandmother' },
  { Code: 'MGGRPRN', Display: 'Maternal great-grandparent' },
  { Code: 'MGRFTH', Display: 'Maternal grandfather' },
  { Code: 'MGRMTH', Display: 'Maternal grandmother' },
  { Code: 'MGRPRN', Display: 'Maternal grandparent' },
  { Code: 'MTH', Display: 'Mother' },
  { Code: 'MTHFOST', Display: 'Foster mother' },
  { Code: 'MTHINLAW', Display: 'Mother-in-law' },
  { Code: 'MUNCLE', Display: 'Maternal uncle' },
  { Code: 'N', Display: 'Next-of-Kin' },
  { Code: 'NBOR', Display: 'Neighbor' },
  { Code: 'NBRO', Display: 'Natural brother' },
  { Code: 'NCHILD', Display: 'Natural child' },
  { Code: 'NEPHEW', Display: 'Nephew' },
  { Code: 'NFTH', Display: 'Natural father' },
  { Code: 'NFTHF', Display: 'Natural father of fetus' },
  { Code: 'NIECE', Display: 'Niece' },
  { Code: 'NIENEPH', Display: 'Niece/nephew' },
  { Code: 'NMTH', Display: 'Natural mother' },
  { Code: 'NMTHF', Display: 'Natural mother of fetus' },
  { Code: 'NonDependant', Display: 'Non Dependant of patient' },
  { Code: 'NotSpecified', Display: 'Not Specified' },
  { Code: 'NPRN', Display: 'Natural parent' },
  { Code: 'NSIB', Display: 'Natural sibling' },
  { Code: 'NSIS', Display: 'Natural sister' },
  { Code: 'O', Display: 'Other' },
  { Code: 'ONESELF', Display: 'Self' },
  { Code: 'PAUNT', Display: 'Paternal aunt' },
  { Code: 'PCOUSN', Display: 'Paternal cousin' },
  { Code: 'Personal', Display: 'Personal relationship with the patient' },
  { Code: 'PGGRFTH', Display: 'Paternal great-grandfather' },
  { Code: 'PGGRMTH', Display: 'Paternal great-grandmother' },
  { Code: 'PGGRPRN', Display: 'Paternal great-grandparent' },
  { Code: 'PGRFTH', Display: 'Paternal grandfather' },
  { Code: 'PGRMTH', Display: 'Paternal grandmother' },
  { Code: 'PGRPRN', Display: 'Paternal grandparent' },
  { Code: 'PolygamousPartner', Display: 'Polygamous Partner of patient' },
  { Code: 'PR', Display: 'Person preparing referral' },
  { Code: 'PRN', Display: 'Parent' },
  { Code: 'PRNFOST', Display: 'Foster parent' },
  { Code: 'PRNINLAW', Display: 'Parent in-law' },
  { Code: 'ProxyCommunication', Display: 'Proxy Communication for patient' },
  { Code: 'ProxyContact', Display: 'Proxy Contact for patient' },
  {
    Code: 'ProxyContactCommunication',
    Display: 'Proxy Contact and Communication for patient'
  },
  { Code: 'PUNCLE', Display: 'Paternal uncle' },
  { Code: 'ROOM', Display: 'Roommate' },
  { Code: 'S', Display: 'State Agency' },
  { Code: 'SIB', Display: 'Sibling' },
  { Code: 'SIBINLAW', Display: 'Sibling in-law' },
  { Code: 'SIGOTHR', Display: 'Significant other' },
  { Code: 'SIS', Display: 'Sister' },
  { Code: 'SISINLAW', Display: 'Sister-in-law' },
  { Code: 'SON', Display: 'Natural son' },
  { Code: 'SONADOPT', Display: 'Adopted son' },
  { Code: 'SONC', Display: 'Son' },
  { Code: 'SONFOST', Display: 'Foster son' },
  { Code: 'SONINLAW', Display: 'Son in-law' },
  { Code: 'SPS', Display: 'Spouse' },
  { Code: 'STPBRO', Display: 'Stepbrother' },
  { Code: 'STPCHLD', Display: 'Step child' },
  { Code: 'STPDAU', Display: 'Stepdaughter' },
  { Code: 'STPFTH', Display: 'Stepfather' },
  { Code: 'STPMTH', Display: 'Stepmother' },
  { Code: 'STPPRN', Display: 'Step parent' },
  { Code: 'STPSIB', Display: 'Step sibling' },
  { Code: 'STPSIS', Display: 'Stepsister' },
  { Code: 'STPSON', Display: 'Stepson' },
  { Code: 'TWIN', Display: 'Twin' },
  { Code: 'TWINBRO', Display: 'Twin brother' },
  { Code: 'TWINSIS', Display: 'Twin sister' },
  { Code: 'U', Display: 'Unknown' },
  { Code: 'UNCLE', Display: 'Uncle' },
  { Code: 'WIFE', Display: 'Wife' }
]

export const relationshipOptions: BaseOptionType[] = relationshipValues.map(
  (value) => ({
    label: value.Display,
    value: value.Code
  })
)
